"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var _brandingVariables = require("./brandingVariables");

var brockMuiTheme = (0, _styles.createTheme)({
  typography: {
    fontFamily: 'Open Sans, Arial, Helvetica, sans-serif'
  },
  palette: {
    action: {
      hover: _brandingVariables.brandingVariables.backing
    }
  },
  overrides: {
    MuiMenuItem: {
      root: {
        color: function color(props) {
          return props.disabled ? _brandingVariables.brandingVariables.accent1 : _brandingVariables.brandingVariables.accent4;
        }
      }
    }
  }
});
var _default = brockMuiTheme;
exports["default"] = _default;